<div class="modal-header pt-4">
  <h5 class="modal-title text-center">Obtenga {{eligibleCashback}}% de reembolso </h5>
</div>


<div class="modal-body pt-2 d-flex flex-column align-items-center">
  <picture class="w-50 pb-4">
    <source srcset="https://www.cubatel.com/images-ads/cdn/assets/cashback/eligible_cashback.webp" type="image/webp">
    <source srcset="https://www.cubatel.com/images-ads/cdn/assets/cashback/eligible_cashback.png" type="image/png">
    <img class="w-100" src="https://www.cubatel.com/images-ads/cdn/assets/cashback/eligible_cashback.png" alt="Obtenga reembolso">
  </picture>
  <p class="text-center mb-0">Ud. obtendrá hasta un {{eligibleCashback}}% de reembolso en transacciones elegibles después
    que la recarga sea entregada. El reembolso obtenido se calcula en función del monto total de la transacción después
    de aplicar los descuentos.</p>
    <p class="text-center mb-0 mt-2 text-muted">Las recargas con un descuento exclusivo no son elegibles para reembolso.</p>
</div>
<div class="modal-footer d-flex flex-column flex-sm-row align-items-center mb-4">
  <button type="button" class="btn btn-primary banner-button modal-banner-button"
    (click)="activeModal.close()">Cerrar</button>
</div>
